export const HIDE_OPEN_IN_APP_MSG = 'HIDE_OPEN_IN_APP_MSG';

export interface IContextAction {
  type: typeof HIDE_OPEN_IN_APP_MSG;
}

export interface IContextState {
  isOpenInAppMessageOpen: boolean;
}
